import { Provider } from "./providers";

const STORAGE = window.localStorage;
const KEY_SELECTED = `rujira-accounts-selected-${import.meta.env.MODE}`;
const KEY_CONNECTED = `rujira-accounts-connected-${import.meta.env.MODE}`;

/**
 * Fetches the persisted Account
 */
export const loadSelected = (): { address?: string } | undefined => {
  const stored = STORAGE.getItem(KEY_SELECTED);
  if (!stored) return undefined;
  const parsed = JSON.parse(stored);

  if (typeof parsed == "object") {
    return parsed;
  } else {
    throw new Error(`Invalid store ${stored}`);
  }
};

/**
 * Persists a selected account
 */
export const saveSelected = (address?: string): void => {
  STORAGE.setItem(KEY_SELECTED, JSON.stringify({ address }));
};

/**
 * Clears the persisted Account
 */
export const clearSelected = (): void => {
  STORAGE.removeItem(KEY_SELECTED);
};

export const loadProviderKeys = (): Provider.Key[] => {
  const stored: Record<Provider.Key, boolean> = JSON.parse(
    STORAGE.getItem(KEY_CONNECTED) || "{}"
  );

  return Object.entries(stored)
    .filter(([_, v]) => v)
    .map(([k]) => k as Provider.Key);
};

export const addProviderKey = (p: Provider.Key): void => {
  const stored: Record<Provider.Key, boolean> = JSON.parse(
    STORAGE.getItem(KEY_CONNECTED) || "{}"
  );
  STORAGE.setItem(KEY_CONNECTED, JSON.stringify({ ...stored, [p]: true }));
};

export const removeProviderKey = (p: Provider.Key): void => {
  const stored: Record<Provider.Key, boolean> = JSON.parse(
    STORAGE.getItem(KEY_CONNECTED) || "{}"
  );
  const { [p]: _d, ...rest } = stored;
  STORAGE.setItem(KEY_CONNECTED, JSON.stringify(rest));
};

export const clearProviderKeys = (): void => {
  STORAGE.removeItem(KEY_CONNECTED);
};
